export const getCurrencyFormatter = (currency: string, locale: Intl.LocalesArgument) => new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: currency,
    trailingZeroDisplay: 'stripIfInteger'
});
